/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Letter_Spacing_Aria_LabelInputs */

const en_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letter Spacing`)
};

const fr_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacement des lettres`)
};

const de_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchstabenabstand`)
};

const it_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaziatura delle lettere`)
};

const ru_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Межбуквенный интервал`)
};

const es_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaciado entre letras`)
};

const zh_cn2_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字母间距`)
};

const ja_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字間隔`)
};

const hi_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पत्र अंतराल`)
};

const pt_pt2_styles_letter_spacing_aria_label = /** @type {(inputs: Styles_Letter_Spacing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaçamento entre letras`)
};

/**
* | output |
* | --- |
* | "Letter Spacing" |
*
* @param {Styles_Letter_Spacing_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_letter_spacing_aria_label = /** @type {((inputs?: Styles_Letter_Spacing_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Letter_Spacing_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_letter_spacing_aria_label(inputs)
	if (locale === "de") return de_styles_letter_spacing_aria_label(inputs)
	if (locale === "it") return it_styles_letter_spacing_aria_label(inputs)
	if (locale === "ru") return ru_styles_letter_spacing_aria_label(inputs)
	if (locale === "es") return es_styles_letter_spacing_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_letter_spacing_aria_label(inputs)
	if (locale === "ja") return ja_styles_letter_spacing_aria_label(inputs)
	if (locale === "hi") return hi_styles_letter_spacing_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_letter_spacing_aria_label(inputs)
	return en_styles_letter_spacing_aria_label(inputs)
});